import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { Eye } from "lucide-react";
import { Link } from "react-router-dom";
import CTAButton from "./CTAButton";
import OptimizedImage from "./OptimizedImage";
import project1 from "@/assets/project-1.webp";
import project2 from "@/assets/project-2.webp";
import project3 from "@/assets/project-3.webp";

const WA_LINK = "https://wa.me/393296281756?text=Ciao%20Danielealoisi%2C%20vorrei%20un%20preventivo%2Fsopralluogo%20per%20infissi%20o%20lavorazioni%20in%20ferro.%20Zona%3A%20_____%20.%20Posso%20inviare%20alcune%20foto.";

const projects = [
  { image: project1, title: "Infissi & Serramenti", subtitle: "PVC, alluminio, effetto legno, legno-alluminio.", alt: "infissi su misura Roma" },
  { image: project2, title: "Ferro & Sicurezza", subtitle: "Grate, cancelli e ringhiere su misura.", alt: "lavorazioni in ferro Guidonia" },
  { image: project3, title: "Riparazioni", subtitle: "Regolazioni e ripristini, valutazione chiara.", alt: "riparazione infissi Roma" },
];

const ProjectsSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-50px" });

  return (
    <section id="projects" ref={ref} className="section-light pb-24 px-6 md:px-12">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {projects.map((project, i) => (
            <motion.div
              key={project.title}
              initial={{ opacity: 0, y: 60 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.8, delay: i * 0.2 }}
              className="group cursor-pointer"
            >
              <a href="#gallery" className="block overflow-hidden rounded-sm relative">
                <motion.div className="w-full aspect-[3/4]">
                  <OptimizedImage
                    src={project.image}
                    alt={project.alt}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                    eager={i === 0}
                  />
                </motion.div>
                <div className="absolute inset-0 bg-background/60 opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex flex-col items-center justify-center gap-2">
                  <Eye size={28} className="text-foreground" />
                  <span className="text-foreground text-xs tracking-widest uppercase font-body">Vedi i lavori</span>
                </div>
              </a>
              <h3 className="mt-4 font-heading text-lg font-semibold text-section-light-foreground">
                {project.title}
              </h3>
              <p className="mt-1 text-sm text-section-light-foreground/50 font-body uppercase tracking-wider">
                {project.subtitle}
              </p>
            </motion.div>
          ))}
        </div>
        <motion.div
          initial={{ opacity: 0 }}
          animate={isInView ? { opacity: 1 } : {}}
          transition={{ duration: 0.6, delay: 0.8 }}
          className="mt-12 flex flex-wrap gap-4"
        >
          <CTAButton className="cta-button-light hover:-translate-y-0.5 active:scale-[0.98] transition-all duration-300" />
          <a
            href={WA_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-8 py-3 text-sm tracking-widest uppercase font-body bg-[#25D366] text-white rounded-sm hover:-translate-y-0.5 active:scale-[0.98] transition-all duration-300"
          >
            Scrivi su WhatsApp
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default ProjectsSection;